import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import Drawer from '../shared/Drawer';
import Input from '../shared/Input';
import Autocomplete from '../shared/Autocomplete';
import DocumentsUpload from '../modals/documents-modal/DocumentsUpload';

import allCountries from '../../constants/countries';

const countriesList = allCountries.map((c) => c.name);

const DocumentModal = (props) => {
  const {
    open,
    onClose,
    loading,
    onSubmit,
    mode,
    initialValues,
    deleteDocument, // ToDo: fix delete functionality
  } = props;

  const [document, setDocument] = useState(null);
  const [description, setDescription] = useState('');
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    if (mode === 'update') {
      setDescription(initialValues?.description || '');
      setCountries(initialValues?.countries || []);
    }
  }, [open, mode, initialValues]);

  const resetValues = () => {
    setDocument(null);
    setDescription('');
    setCountries([]);
  };

  const handleSubmit = async () => {
    await onSubmit(document, description, countries);
    resetValues();
  };

  const onUploadComplete = (document) => {
    setDocument(document);
  };

  return (
    <Drawer
      open={open}
      onClose={() => {
        resetValues();
        onClose();
      }}
      title={mode === 'update' ? 'Edit Document' : 'Add Document'}
      submitText="Submit"
      disabled={(mode !== 'update' && !document) || loading}
      loading={loading}
      onSubmit={handleSubmit}
    >
      <Box sx={{ minWidth: { xs: 'auto', md: '560px' } }}>
        {mode !== 'update' && (
          <>
            <Typography sx={{ fontSize: 14 }}>Upload</Typography>
            <DocumentsUpload onUploadComplete={onUploadComplete} onDelete={deleteDocument} multiple={false} />
          </>
        )}
        <Input
          id="description"
          type="text"
          placeholder=""
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          label="Description"
          multiline
        />
        <div className="p-t-md">
          <Autocomplete
            multiple
            value={countries}
            onChange={setCountries}
            options={countriesList}
            label="Countries"
          />
        </div>
      </Box>
    </Drawer>
  );
};

DocumentModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default DocumentModal;
